import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

import { APP_PAGES, APP_LAYOUT, APP_SIDER_MENU } from '../../../../data/config/constants';
import { pageChanged } from '../../../../data/redux/page_details/actions';

import PageNavbar from '../../../../components/pagenavbar';

class Settings extends Component {
  state = { menu: [] }

  componentWillMount() {
    let { actions } = this.props;
    let menu = APP_SIDER_MENU.find(item => { return (item.app_page === APP_PAGES.SETTINGS) });
    this.setState({ menu });
    actions.pageChanged(APP_PAGES.SETTINGS, APP_PAGES.SETTINGS);
  }

  render() {
    const { page_details, admin_details, children, history } = this.props;
    const screen_height = page_details.device_data.screen_height;
    const mobile = page_details.device_data.screen_width < 768;
    return (
      <div className={`ori-full-width ${mobile ? "" : "ori-flex-row"}`}>
        <PageNavbar title={APP_PAGES.SETTINGS} page_details={page_details} admin_details={admin_details} menu={this.state.menu} navigateTo={history.push} bordered column bg_white box_shadow />
        <div className="ori-full-flex ori-overflow-y-auto ori-overflow-x-hidden" style={{ height: mobile ? `${screen_height - APP_LAYOUT.APP_HEADER_HEIGHT - APP_LAYOUT.PAGE_NAVBAR_HEIGHT}px` : `${screen_height - APP_LAYOUT.APP_HEADER_HEIGHT}px` }}>
          {children}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    page_details: state.page_details,
    admin_details: state.admin_details,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators({ pageChanged }, dispatch)
  };
};

Settings.propTypes = {
  page_details: PropTypes.object,
  admin_details: PropTypes.object,
  history: PropTypes.object,
  location: PropTypes.object,
  match: PropTypes.object,
  actions: PropTypes.object,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(Settings));




// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/settings/index.js